<template>
  <div class="add-entity container">
    <h2 class="center-align indigo-text">Add New Entity</h2>
    <form @submit.prevent="AddEntity">
      <div class="field title">
        <label for="name">Entity Name:</label>
        <input type="text" name="name" v-model="name">
      </div>
      <div class="field">
        <label for="type">Entity type:</label>

        <select class="browser-default" v-model="type">
          <option v-for="option in typeOptions" :value="option.value" :key="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>
      <div class="field center-align">
          <p v-if="feedback" class ="red-text">{{ feedback }}</p>
          <button class="btn pink">Add Entity</button>
      </div>
    </form>
  </div>
</template>

<script>
import db from '@/firebase/init'
import slugify from 'slugify'

export default {
  name: "AddEntity",
  props: ['entities', 'entityType',],
  data () {
    return {
      hasGone: false,
      initiative: "",
      isActive: false,
      isGM: false,
      inScenario: false,
      isPresent: false,
      name: "",
      subInitiative: "",
      type: this.entityType,
      feedback: "",
      typeOptions: [
        {text: 'Player', value: 'player'},
        {text: 'Monster', value: 'monster'},
        {text: 'Boss', value: 'boss'},
        {text: 'Bug', value: 'bug'},
        {text: 'Accepted Feature', value: 'acceptedFeature'},
        {text: 'Idea', value: 'idea'},
        {text: 'Resource', value: 'resource'},
      ],
    }
  },
  methods: {
    AddEntity(){
      
      // check if info completely filled in
      if (this.name){
        this.feedback = null
        let ourNewObject = {
          name: this.name,
          type: this.type,
          imageID: this.imageID,
          isActive: this.isActive,
          hasGone: this.hasGone,
          initiative: this.initiative,
          subInitiative: this.subInitiative,
          isGM: this.isGM,
          inScenario: this.inScenario,
          isPresent: this.isPresent,
        }
        // add to database
        this.entities.push(ourNewObject)
        db.collection('entities').add(ourNewObject).then((data) => {
          this.$router.push({ name: 'ScenarioStart' })
          ourNewObject.id = data.id
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.feedback = "You must fill in everything."
      }
    }
  },
  computed: {
    imageID(){
      let sluggifiedName = slugify(this.name, {
        remove: /[$*_+~.()'"!\-:@]/g,
        lower: true})
      return sluggifiedName + 'image.jpg'
    }
  }
}
</script>

<style scoped>
.add-entity{
    margin-top: 60px;
    padding: 20px;
    max-width: 500px;
}
.add-entity h2{
    font-size: 2em;
    margin: 20px auto;
}
.add-entity .field{
    margin: 20px auto;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/AddEntity.vue